import { render, staticRenderFns } from "./SuspendUserModal.vue?vue&type=template&id=c4be56e2&"
import script from "./SuspendUserModal.vue?vue&type=script&lang=ts&"
export * from "./SuspendUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports